// @flow

import React from 'react';
import _ from 'lodash';
import bemify, { toModifiers } from 'bemify-js';

import 'app/common/components/Dropdown.scss';

import { type KindType } from 'app/common/types';

const bem = bemify('dropdown');

// Styles something as a dropdown. Use the `tag` prop to customize which HTML tag gets rendered.
// Note that this component only handles styling. Any additional dropdown-ish functionality should
// be kept separate (See e.g. `DropdownMenu`)!
type Props = {
  className?: string,
  kind?: KindType,
  tag: string,
};

// Note: this needs to be a class so we can pass `ref` from outside
class Dropdown extends React.Component<Props, {}> {
  static defaultProps = {
    tag: 'div',
  };

  render() {
    const { props } = this;
    const className = bem(toModifiers(props.kind), props.className);
    const passthroughProps = _.omit(props, ['className', 'kind', 'tag']);

    return <props.tag className={className} {...passthroughProps} />;
  }
}

export default Dropdown;
